require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./law-enforcement-assisted-diversion.json") })
        }
      }, "path---law-enforcement-assisted-diversion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---law-enforcement-assisted-diversion!./.cache/json/law-enforcement-assisted-diversion.json
// module id = 923
// module chunks = 231608221292675